import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "lucide-react";
import type { SearchResultGroup as SearchResultGroupType } from "@/hooks/use-global-search";
import { SearchResultItem } from "./SearchResultItem";

interface ResultGroupProps {
  group: SearchResultGroupType;
  onItemClick: () => void;
  onShowAll: (type: string) => void;
}

export const SearchResultGroup = React.memo(function SearchResultGroup({
  group,
  onItemClick,
  onShowAll,
}: ResultGroupProps) {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex items-center justify-between px-4 py-2 bg-muted/50">
        <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
          {t(`globalSearch.type_${group.type}`, group.label)}
        </h3>
        {group.total > 3 && (
          <button
            onClick={() => onShowAll(group.type)}
            className="text-xs text-primary hover:underline flex items-center gap-0.5"
          >
            {t("globalSearch.showAll", "Show all")} ({group.total})
            <ChevronRight className="h-3 w-3" />
          </button>
        )}
      </div>
      {group.items.map((item) => (
        <SearchResultItem key={`${item.type}-${item.id}`} entry={item} onClick={onItemClick} />
      ))}
    </div>
  );
});
